const PERMISSION_KEY= "personalize:nebula_decision_templates";
const PAGE_URL = {
    NEBULA_DECISION_TEMPLATES_PAGE: "/admin/personalize/nebula-decision-templates"
}

export {PERMISSION_KEY, PAGE_URL}

